import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendIntegrationAsset, BackendQueryIntegrationAssetsArgs } from 'src/types/backend';

import { INTEGRATION_ASSET_STATUS } from './schema';

const QUERY = gql`
  query IntegrationAssetStatus(
    $customerId: ID!
    $dataSource: PerformanceCenterDataSource
    $accountId: ID
    $statuses: [IntegrationAssetStatus!]
  ) {
    integrationAssets(
      customerId: $customerId
      dataSource: $dataSource
      accountId: $accountId
      statuses: $statuses
    ) {
      ...IntegrationAssetStatus
    }
  }
  ${INTEGRATION_ASSET_STATUS}
`;

type Variables = Pick<
  BackendQueryIntegrationAssetsArgs,
  'customerId' | 'accountId' | 'dataSource' | 'statuses'
>;
type Result = BackendIntegrationAsset[];

export const queryIntegrationAssetStatus = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp<Result>(result.data);
};
